import { FigmaImage, useNotionDatabase } from "dev";

type Props = {
  databaseId: string;
};
export default function NotionDatabase({ databaseId }: Props) {
  const db = useNotionDatabase(databaseId);

  if (!db || !db.length) return null; // not loaded or no data

  const headers = Object.keys(db[0]);

  return (
    <table>
      <thead>
        <tr className="bg-red-100">
          {headers.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {db.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {headers.map((header, cellIndex) => {
              const cell = row[header];

              if (header === "figma_url" && cell) {
                return (
                  <td key={cellIndex}>
                    <FigmaImage
                      key={cellIndex.toString()}
                      url={cell}
                      fetchDelayMs={cellIndex * 100}
                    />
                  </td>
                );
              }

              return <td key={cellIndex}>{cell}</td>;
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
